import * as React from "react";
import { Link } from "gatsby";
import { get } from "lodash";
import { Message, Table, Header, Container, Segment, Icon, Label, Image } from "semantic-ui-react";
import { ContentfulCourse } from "../graphql-types";
import BlogTitle from "../components/BlogTitle";
import { DiscussionEmbed } from "disqus-react";
import {withLayout, LayoutProps} from "../components/Layout";
import { graphql } from "gatsby";
import * as assert from "assert";

interface CourseAssnPageProps extends LayoutProps {
  data: {
    course: ContentfulCourse;
  };
}

const CourseAssnPage = (props: CourseAssnPageProps) => {
  const { courseName, courseNumber, semester, syllabus } = props.data.course;
  const assignments = props.data.course.assignments;

  const courseHeader =
    <Header as="h1">
      {courseNumber}: {courseName} Assignments
      <Header.Subheader>{semester}</Header.Subheader>
    </Header>;

  if (!assignments) {
    return <Container text>
        {courseHeader}
        <Message negative>There are no assignments yet.</Message>
      </Container>;
  }

  const generalInstructions = assignments.generalInstructions.childContentfulRichText.html;
  return <Container text>
      {courseHeader}
      <div dangerouslySetInnerHTML={{ __html: generalInstructions }} />
      <Header>
        <Header.Content>Assignments</Header.Content>
      </Header>
      <Table striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Due date</Table.HeaderCell>
            <Table.HeaderCell>Points</Table.HeaderCell>
            <Table.HeaderCell>Submission</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {assignments.assignments && assignments.assignments.map((assignment) => {
            const link = assignment.assignmentFile ? 
              <a href={`https:${assignment.assignmentFile[0].file.url}`}> {assignment.name} </a> : 
              <div dangerouslySetInnerHTML={{ __html: assignment.assignmentLink.childContentfulRichText.html }} />;
            const date = new Date(assignment.dueDate);
            const formatDate = date.toLocaleString("en-US", {
              timeZone: "America/New_York",
            });
            return <Table.Row>
                <Table.Cell>
                  {link}
                </Table.Cell>
                <Table.Cell>{formatDate}</Table.Cell>
                <Table.Cell>{assignment.points}</Table.Cell>
                <Table.Cell>
                  <div dangerouslySetInnerHTML={{ __html: assignment.submission.childContentfulRichText.html }} />
                </Table.Cell>
              </Table.Row>;
          })}
        </Table.Body>
      </Table>
    </Container>;
};

export default withLayout(CourseAssnPage);

export const pageQuery = graphql`
  query TemplateCourseAssnPage($slug: String!) {
  course: contentfulCourse(fields: {slug: {eq: $slug}}) {
		assignments {
			generalInstructions {
				childContentfulRichText {
          html
        }
      }
      assignments {
        description
        name
        dueDate
        points
        assignmentFile {
          file {
            url
          }
        }
        assignmentLink {
          childContentfulRichText {
            
            html
          }
        }
        submission {
          childContentfulRichText {
            html
          }
        }
        
      }
    }
    courseName
    courseNumber
    semester
    fields {
      slug
    }
  }
}
`;
